/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
import React from 'react';
import {
    signIn as amplifySignIn,
    confirmSignIn,
    signUp as amplifySignUp,
    confirmSignUp as amplifyConfirmSignUp,
    resetPassword,
    confirmResetPassword,
    signInWithRedirect,
    updateUserAttributes as amplifyUpdateUserAttributes,
} from 'aws-amplify/auth';
import { toQueryParams } from 'utils';
import { AuthState, Challenges } from './constants';
import { AuthContext } from './context';
import config from './config';

class AuthComponent extends React.Component {
    _validAuthStates;

    constructor(props) {
        super(props);

        this._validAuthStates = [];
        this.changeState = this.changeState.bind(this);
        this.error = this.error.bind(this);
    }

    errorMessage(err) {
        if (typeof err === 'string') {
            return err;
        }
        return err.message ? err.message : JSON.stringify(err);
    }

    triggerAuthEvent(event) {
        const { authState, onAuthEvent } = this.context;
        if (onAuthEvent) {
            onAuthEvent(authState, event);
        }
    }

    async changeState(state, data) {
        const { authData, changeState } = this.context;

        if (changeState) {
            await changeState(state, {
                ...authData,
                ...data
            });
        }

        this.triggerAuthEvent({
            type: 'stateChange',
            data: state,
        });
    }

    error(err) {
        this.triggerAuthEvent({
            type: 'error',
            data: this.errorMessage(err),
        });
    }

    async updateUser(data) {
        await amplifyUpdateUserAttributes({ userAttributes: data });
    }

    signIn = async (signInData) => {
        const { username, password, meta } = signInData;
        try {
            const { isSignedIn, nextStep } = await amplifySignIn({
                username,
                password,
                options: meta ? { clientMetadata: meta } : undefined,
            });

            if (isSignedIn) {
                // signed in without challenge — checkUser will be triggered via Hub
                return;
            }

            const data = { ...signInData };

            switch (nextStep.signInStep) {
                case Challenges.SMS_MFA:
                case Challenges.SOFTWARE_TOKEN_MFA:
                    this.changeState(AuthState.ConfirmSignIn, data);
                    break;
                case Challenges.NEW_PASSWORD_REQUIRED:
                    this.changeState(AuthState.RequireNewPassword, data);
                    break;
                case Challenges.MFA_SETUP:
                    this.changeState(AuthState.MFASetup, data);
                    break;
                case Challenges.CUSTOM_CHALLENGE:
                    this.changeState(AuthState.CustomConfirmSignIn, data);
                    break;
                default:
                    break;
            }
        } catch (err) {
            if (err.name === 'UserNotConfirmedException') {
                this.changeState(AuthState.ConfirmSignUp, signInData);
            } else if (err.name === 'PasswordResetRequiredException') {
                this.changeState(AuthState.ForgotPassword, signInData);
            } else {
                this.error(err);
            }
        }
    };

    sendCustomChallengeAnswer = async (code) => {
        confirmSignIn({ challengeResponse: code })
            .then(({ isSignedIn }) => {
                if (!isSignedIn) {
                    this.error('Invalid Verification Code');
                } else {
                    this.changeState(AuthState.SignedIn);
                }
            })
            .catch((err) => {
                if (err.name === 'NotAuthorizedException') {
                    this.error('Too many attempts or expired code. Please go back and try again.');
                } else this.error(err);
            });
    };

    signUp = async (signUpData) => {
        const { username, password, attributes, validationData, clientMetadata } = signUpData;
        this.changeState(AuthState.ConfirmSignUp, signUpData);

        return amplifySignUp({
            username,
            password,
            options: { userAttributes: attributes, validationData, clientMetadata },
        })
            .then(() => {
                this.changeState(AuthState.ConfirmSignUp, signUpData);
            })
            .catch(this.error);
    };

    confirmSignUp = (code) => {
        const { authData } = this.context;
        const { username } = authData;

        return amplifyConfirmSignUp({ username, confirmationCode: code })
            .then(async ({ isSignUpComplete }) => {
                if (isSignUpComplete) {
                    await this.signIn(authData);
                }
            })
            .catch(this.error);
    };

    sendPasswordResetCode = (username) => {
        if (!username) {
            return this.error('Username is empty');
        }
        return resetPassword({ username })
            .then(({ nextStep }) => {
                const delivery = nextStep.codeDeliveryDetails;
                this.changeState(AuthState.ForgotPasswordCode, { username, delivery });
            })
            .catch(this.error);
    };

    forgotPasswordSubmit = ({ username, password, code }) =>
        confirmResetPassword({ username, confirmationCode: code, newPassword: password })
            .then(() => this.signIn({ username, password }))
            .catch(this.error);

    signInSAML = (idProvider) => {
        signInWithRedirect({ provider: { custom: idProvider } });
    };

    render() {
        const { authState } = this.context;
        if (!this._validAuthStates.includes(authState)) {
            return null;
        }
        return this.showComponent();
    }

    showComponent() {
        throw new Error('You must implement showComponent() and don\'t forget to set this._validAuthStates.');
    }
}

AuthComponent.contextType = AuthContext;

export { AuthComponent };
